<template>
<div v-show="showFilterBlock" class="titles-filter" id="titles-filter">
    <div class="filter_block">
        <div class="range_year_wrapper">
            
                <!-- <label for="">C: </label>
                <input @keyup.enter="filterByYear()" v-model="filter_year" type="number" min="1900" max="2099" step="1" value="2016" /> -->
                <div class="wrapper">
                    <div class="values">
                        <span ref="range1" id="range1">
                            1970
                        </span>
                        <span> &dash; </span>
                        <span ref="range2" id="range2">
                            2025
                        </span>
                    </div>
                    <div class="container">
                        <div ref="slider_track" class="slider-track"></div>
                        <input ref="slider_one" type="range" min="1960" :max="maxYearRange" value="1960" id="slider-1" @input="slideOne" @change="showAnimeByFilter">
                        <input ref="slider_two" type="range" min="1960" :max="maxYearRange" :value="maxYearRange" id="slider-2" @input="slideTwo" @change="showAnimeByFilter">
                    </div>
                </div>
            
            
             <!-- <div class="to_year">
                <label for="">По: </label>
                <input @keyup.enter="filterByYear()" v-model="filter_year_end" type="number" min="1900" max="2099" step="1" value="2023" />
             </div> -->
            <div class="selects_wrapper">
            
                <div class="select_wrapper">
                    <select id="select_multiple_genres"></select>
                </div>
                <div class="select_wrapper">
                    <select id="select_multiple_studios"></select>
                </div>
                <div class="select_wrapper">
                    <select id="select_multiple_types"></select>
                </div>
                <div class="select_wrapper">
                    <select id="select_multiple_status"></select>
                </div>
                <div class="select_wrapper">
                    <select id="select_multiple_mpaa"></select>
                </div>
                <div class="select_wrapper">
                    <input id="select_multiple_rating" value="Оценка" placeholder="4-7.9"/>
                </div>
            </div> 
        </div>    
    </div>
</div>
</template>

<script>
import axios from "axios";

export default {
props:{
    showFilterBlock: {
        type: Boolean,
        required: true
    }
},
data(){
    return {
        filter_year: 1970,
        filter_year_end: new Date().getFullYear(),
        yearRange: new Date().getFullYear().toString(),
        maxYearRange: new Date().getFullYear(),
        listOfGenres: null,
        listOfStudios: null,
        listOfTypes: null,
        listOfStatus: null,
        listOfMpaa: null,
        listOfRating: null
    }
},
watch:{
    $route(newPath, oldPath){
        
        // if(this.isFilterBlock){
            console.log('WATCH FILTER');
            this.showAnimeByFilter();
        // }
    }
},
mounted(){
    document.querySelector('head title').textContent = 'Фильтр';
    
    this.yearRange = this.getYearRange(this.filter_year, this.filter_year_end);
    this.initSelectr()

    let sliderOne = this.$refs.slider_one;
    let sliderTwo = this.$refs.slider_two;
    let minGap = 0;
   
    this.slideOne();
    this.slideTwo();
},
methods: {
    slideOne(){
        let minGap = 0;
        let sliderOne = this.$refs.slider_one;
        let sliderTwo = this.$refs.slider_two;
        let displayValOne = this.$refs.range1;
        
        if(parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap){
            sliderOne.value = parseInt(sliderTwo.value) - minGap;
        }
        this.filter_year = sliderOne.value;
        this.yearRange = this.getYearRange(this.filter_year, this.filter_year_end);
        displayValOne.textContent = sliderOne.value;
        
        this.fillColor();
    },
    slideTwo(){
        let minGap = 0;
        let sliderOne = this.$refs.slider_one;
        let sliderTwo = this.$refs.slider_two;
        let displayValTwo = this.$refs.range2;

        if(parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap){
            sliderTwo.value = parseInt(sliderOne.value) + minGap;
        }
        this.filter_year_end = sliderTwo.value;
        console.log(this.filter_year_end);
        this.yearRange = this.getYearRange(this.filter_year, this.filter_year_end);
        displayValTwo.textContent = sliderTwo.value;
        this.fillColor();
    },
    fillColor(){
        let sliderOne = this.$refs.slider_one;
        let sliderTwo = this.$refs.slider_two;
        let sliderTrack = this.$refs.slider_track;
        let sliderMaxValue = this.$refs.slider_one.max;
        
        let percent1 = ((sliderOne.value - 1960) / (this.maxYearRange - 1960)) * 100;
        console.log(percent1)
        let percent2 = ((sliderTwo.value - 1960) / (this.maxYearRange - 1960)) * 100;
        sliderTrack.style.background = `linear-gradient(to right, #dadae5 ${percent1}% , #3264fe ${percent1}% , #3264fe ${percent2}%, #dadae5 ${percent2}%)`;
    },
    filterByMpaa(){
    let that = this;
    
    let selectrData = new Selectr('#select_multiple_mpaa', {
        data: [
            { value: 'G', text: 'G' },
            { value: 'PG', text: 'PG' },
            { value: 'PG-13', text: 'PG-13' },
            { value: 'R', text: 'R' },
            { value: 'R+', text: 'R+' },
            { value: 'Rx', text: 'Rx' },
        ],
        searchable: false,
        multiple: true,
        placeholder: 'Рейтинг'
    });
    selectrData.on('selectr.change', function(option) {
        console.log(selectrData.getValue());
        let arrToString = selectrData.getValue().toString().replaceAll(/[\]\[]+/g,'');
        that.listOfMpaa = arrToString;
        // console.log(this.listOfGenres);
        that.showAnimeByFilter();
    });
     
    },
    filterByStatus: function(){
    let that = this;

    let selectrData = new Selectr('#select_multiple_status', {
        data: [
            { value: 'anons', text: 'Анонс' },
            { value: 'ongoing', text: 'Выходит' },
            { value: 'released', text: 'Вышел' },
        ],
        searchable: false,
        multiple: true,
        placeholder: 'Статус'
    });
    selectrData.on('selectr.change', function(option) {
        console.log(selectrData.getValue());
        let arrToString = selectrData.getValue().toString().replaceAll(/[\]\[]+/g,'');
        that.listOfStatus = arrToString;
        // console.log(this.listOfGenres);
        that.showAnimeByFilter();
    });
    },
    filterByTypes: function(){
        let that = this;
        let selectrData = new Selectr('#select_multiple_types', {
            data: [
                { value: 'tv', text: 'Сериал' },
                { value: 'movie', text: 'Фильм' },
                { value: 'ova', text: 'OVA' },
                { value: 'ona', text: 'ONA' },
                { value: 'special', text: 'Спешл' },
                { value: 'music', text: 'Музыка' }
            ],
            searchable: false,
            width: 200,
            multiple: true,
            customClass: "custom-style",
            placeholder: 'Тип'
        });
    selectrData.on('selectr.change', function(option) {
        console.log(selectrData.getValue());
        let arrToString = selectrData.getValue().toString().replaceAll(/[\]\[]+/g,'');
        that.listOfTypes = arrToString;
        // console.log(this.listOfGenres);
        that.showAnimeByFilter();
    });
    },
    filterByYear: function(){
        this.yearRange = this.getYearRange(this.filter_year, this.filter_year_end);
        console.log(this.yearRange);
        this.showAnimeByFilter();
    },
    getYearRange(year_begin, year_end){
        let rangeOfYears = '';
        for(let i = year_begin;i <= year_end;i++){
            rangeOfYears += i == year_end ? i : i + ','; 
        }
        return rangeOfYears;
    },
    filterByGenres: function(){
        let that = this;
        let selectrData = new Selectr('#select_multiple_genres', {
            data: [
                { value: 'Безумие', text: 'Безумие' },
                { value: 'Боевые искусства', text: 'Боевые искусства' },
                { value: 'Вампиры', text: 'Вампиры' },
                { value: 'Военное', text: 'Военное' },
                { value: 'Гарем', text: 'Гарем' },
                { value: 'Гурман', text: 'Гурман' },
                { value: 'Демоны', text: 'Демоны' },
                { value: 'Детектив', text: 'Детектив' },
                { value: 'Детское', text: 'Детское' },
                { value: 'Дзёсей', text: 'Дзёсей' },
                { value: 'Драма', text: 'Драма' },
                { value: 'Игры', text: 'Игры' },
                { value: 'Исторический', text: 'Исторический' },
                { value: 'Комедия', text: 'Комедия' },
                { value: 'Космос', text: 'Космос' },
                { value: 'Машины', text: 'Машины' },
                { value: 'Меха', text: 'Меха' },
                { value: 'Музыка', text: 'Музыка' },
                { value: 'Пародия', text: 'Пародия' },
                { value: 'Повседневность', text: 'Повседневность' },
                { value: 'Полиция', text: 'Полиция' },
                { value: 'Приключения', text: 'Приключения' },
                { value: 'Психологическое', text: 'Психологическое' },
                { value: 'Романтика', text: 'Романтика' },
                { value: 'Самураи', text: 'Самураи' },
                { value: 'Сверхъестественное', text: 'Сверхъестественное' },
                { value: 'Сёдзё', text: 'Сёдзё' },
                { value: 'Сёнен', text: 'Сёнен' },
                { value: 'Сёнен-ай', text: 'Сёнен-ай' },
                { value: 'Спорт', text: 'Спорт' },
                { value: 'Суперсила', text: 'Суперсила' },
                { value: 'Театр мировых шедевров', text: 'Театр мировых шедевров' },
                { value: 'Триллер', text: 'Триллер' },
                { value: 'Ужасы', text: 'Ужасы' },
                { value: 'Фантастика', text: 'Фантастика'},
                { value: 'Фэнтези', text: 'Фэнтези'},
                { value: 'Школа', text: 'Школа'},
                { value: 'Экшен', text: 'Экшен'},
                { value: 'Этти', text: 'Этти'}
            ],
            searchable: true,
            multiple: true,
            placeholder: 'Жанр'
        });
        selectrData.on('selectr.change', function(option) {
            console.log(selectrData.getValue());
            let arrToString = selectrData.getValue().toString().replaceAll(/[\]\[]+/g,'');
            that.listOfGenres = arrToString;
            // console.log(this.listOfGenres);
            that.showAnimeByFilter();
        });
    },
    filterByStudios: function(){
        let that = this;
        let selectrData = new Selectr('#select_multiple_studios', {
            customClass: 'custom-style-studios',
            data: [
                { value: 'Trigger', text: 'Trigger' },
                { value: 'Bakken Record', text: 'Bakken Record' },
                { value: 'Kamikaze Douga', text: 'Kamikaze Douga' },
                { value: 'Kyoto Animation', text: 'Kyoto Animation' },
                { value: 'Fanworks', text: 'Fanworks' },
                { value: 'TMS Entertainment', text: 'TMS Entertainment' },
                { value: 'MAPPA', text: 'MAPPA' },
                { value: 'Lerche', text: 'Lerche' },
                { value: '8bit', text: '8bit' },
                { value: 'Bibury Animation Studios', text: 'Bibury Animation Studios' },
                { value: 'Gonzo', text: 'Gonzo' },
                { value: 'Shuka', text: 'Shuka' },
            ],
            searchable: true,
            multiple: true,
            placeholder: 'Студия',
        });

        selectrData.on('selectr.change', function(option) {
            console.log(selectrData.getValue());
            let arrToString = selectrData.getValue().toString().replaceAll(/[\]\[]+/g,'');
            that.listOfStudios = arrToString;
            that.showAnimeByFilter();
        });
        
    },
    filterByRating: function(){
        let that = this;
        let rating_input = document.querySelector('#select_multiple_rating');
        rating_input.onclick = function(){
            if(rating_input.value === "Оценка"){
                rating_input.value = "";
            }
        }
        rating_input.oninput = function(){
            that.listOfRating = rating_input.value;

            function isValid(){
                function isNumeric(n) { return !isNaN(parseFloat(n)) && isFinite(n); }
                let range_nums = that.listOfRating.split('-')
                return (range_nums.length === 2 && (range_nums[0] !== "" && isNumeric(range_nums[0]) && range_nums[1] !== "" && isNumeric(range_nums[1])));
            }

            if(isValid()){
                console.log(that.listOfRating);
                that.showAnimeByFilter();
            }
        }
    },
    multipleRange: function(){
        window.onload = function(){
            slideOne();
            slideTwo();
        }
        let sliderOne = document.getElementById("slider-1");
        let sliderTwo = document.getElementById("slider-2");
        let displayValOne = document.getElementById("range1");
        let displayValTwo = document.getElementById("range2");
        let minGap = 0;
        let sliderTrack = document.querySelector(".slider-track");
        let sliderMaxValue = document.getElementById("slider-1").max;
        function slideOne(){
            if(parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap){
                sliderOne.value = parseInt(sliderTwo.value) - minGap;
            }
            displayValOne.textContent = sliderOne.value;
            fillColor();
        }
        function slideTwo(){
            if(parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap){
                sliderTwo.value = parseInt(sliderOne.value) + minGap;
            }
            displayValTwo.textContent = sliderTwo.value;
            fillColor();
        }
        function fillColor(){
            percent1 = (sliderOne.value / sliderMaxValue) * 100;
            percent2 = (sliderTwo.value / sliderMaxValue) * 100;
            sliderTrack.style.background = `linear-gradient(to right, #dadae5 ${percent1}% , #3264fe ${percent1}% , #3264fe ${percent2}%, #dadae5 ${percent2}%)`;
        }
    },
    showAnimeByFilter: function(){
        if(this.listOfGenres || this.listOfStudios || this.listOfTypes){
            this.listOfGenres = this.listOfGenres;
            this.listOfStudios = this.listOfStudios;
            this.listOfTypes = this.listOfTypes;
        }
        
        let url = `https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&lgbt=false&sort=year&year=${this.yearRange}${this.listOfTypes ? '&anime_kind=' + this.listOfTypes : '&anime_kind=tv,movie,ova,ona,special,music'}${this.listOfGenres ? '&anime_genres=' + this.listOfGenres : ''}${this.listOfStudios ? '&anime_studios=' + this.listOfStudios : ''}${this.listOfStatus ? '&anime_status=' + this.listOfStatus : ''}${this.listOfMpaa ? '&rating_mpaa=' + this.listOfMpaa : ''}${this.listOfRating ? '&shikimori_rating=' + this.listOfRating : ''}`;
        // let url = `https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&types=anime,anime-serial&${this.listOfGenres ? '&anime_genres=' + this.listOfGenres : ''}${this.listOfStudios ? '&anime_studios=' + this.listOfStudios : ''}`;
        console.log(url);
        
        axios.get(url).then((response) => {
            console.log(response.data.next_page);
            let nextPage = response.data.next_page;
            let animeList = this.removeDuplicates(response.data.results);
            console.log(animeList);
            this.$emit('update', animeList, nextPage)
        }).catch((error) => {
            console.error(error);
        });
    },
    initSelectr(){
        this.filterByGenres();
        this.filterByStudios();
        this.filterByTypes();
        this.filterByStatus();
        this.filterByMpaa();
        this.filterByRating();
    },
    //CLEAN FUNCTION(Интересно работает)
    //Описание: Удаляем дубликаты из массива и возвращаем массив без дублей
    //@param {array} берет масси
    //@return {array} возвращает новый массив без дубликатов
    removeDuplicates: function(arr) {
        const result = [];
        const titles = new Set(); // Создаем пустой Set для хранения уникальных titles
        // Итерируемся по массиву и добавляем объект в результирующий массив, только если его title не был добавлен ранее в Set
        arr.forEach(obj => {
        if (!titles.has(obj.shikimori_id)) {
            result.push(obj);
            titles.add(obj.shikimori_id);
        }
        });
        return result;
    }
}
}

</script>

<style scoped>


.select_wrapper #select_multiple_rating{
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    width: 100%;
    height: 38px;
    padding: 7px 28px 7px 14px;
    cursor: pointer;
    border: 1px solid rgba(85, 85, 85, 0.37);
    border-radius: 3px;
    background-color: rgba(34, 34, 34, 0.41);
    color: white;
    font-family: "Exo 2", sans-serif;
    font-size: 16px;
}

.titles-filter{
    widows: 100%;
    border: 1px solid #5555555e;
    border-radius: 8px;
    background: #2a2a2a99;
    padding: 14px;
    box-sizing: border-box;
}


.filter_block{
    display: flex;
    justify-content: center;
    align-items: center;
}


.select_wrapper{
    min-width: 150px;
    max-width: 150px;
    margin: 0 6px 0 6px;
    border-radius: 10px;
    display: inline-block;
}

li{
    color: black !important;
}
.custom-style .selectr-selected,
.custom-style .selectr-options-container{
    border-radius: 10px !important;
    background-color: #22222269 !important;
    border: 1px solid #5555555e;
    color: rgb(0, 0, 0);
}

.custom-style .selectr-label,
.custom-style .selectr-option {
	font-family: "Raleway";
}

.custom-style .selectr-selected::before {
	border-color: #fff transparent transparent;
}

.selectr-container.custom-style.open .selectr-selected::before {
  border-width: 0 4px 4px 4px;
  border-color: transparent transparent #fff;
}

.custom-style.open .selectr-selected {
	border-color: #34495e #34495e transparent;
	border-radius: 0;
}

.custom-style .selectr-selected,
.custom-style .selectr-options-container {
	background-color: #34495e !important;
	border-color: #34495e;
	border-radius: 0;
}

.custom-style .selectr-placeholder,
.custom-style .selectr-label {
	color: #ecf0f1;
}

.custom-style .selectr-selected::after {
	border-color: #ecf0f1 transparent transparent;
}

.custom-style .selectr-tag {
	background-color: #2c3e50;
	border-color: #2c3e50;
	border-radius: 0;
	color: #ecf0f1;
}

.custom-style .selectr-input {
	background-color: #2c3e50;
	border-color: #2c3e50;
	color: #ecf0f1;
	font-family: "Roboto Condensed";
}

.custom-style .selectr-clear::before,
.custom-style .selectr-clear::after,
.custom-style .selectr-tag-remove::before,
.custom-style .selectr-tag-remove::after {
	background-color: #2ecc71;
	height: 10px;
	top: 4px;
	width: 2px;
}

.custom-style .selectr-options li {
	color: #ecf0f1;
}

.custom-style .selectr-option.active,
.custom-style .selectr-option.active:hover,
.custom-style .selectr-option.selected:hover,
.custom-style .selectr-option.selected.active,
.custom-style .selectr-option.selected.active:hover {
	background-color: #2ecc71;
	color: #ecf0f1;
}

.custom-style .selectr-option.selected {
	background-color: #2c3e50;
}

.custom-style .selectr-option:hover:not(.disabled) {
	background-color: #2c3e50;
}

.custom-style .selectr-option::after {
	font-family: Material Design Icons;
	position: absolute;
	right: 5px;
	top: 5px;
}

.custom-style .selectr-option.selected::after {
	color: #2ecc71;
	content: "";
}

.custom-style .selectr-option.active:hover::after,
.custom-style .selectr-option.selected:hover::after {
	color: #ecf0f1;
}

.custom-style .selectr-option.disabled {
	cursor: not-allowed;
	opacity: 1;
}

.selectr-option.disabled .color-option {
	opacity: 0.2;
}

.custom-style .selectr-option.disabled::after {
	color: #c0392b;
	content: "";
}

.custom-style .selectr-notice {
	background-color: #34495e;
	border-color: #34495e;
	color: #ecf0f1;
}

.custom-style .selectr-tag-input {
	background-color: transparent;
	color: #ecf0f1;
}

.custom-style .selectr-tag-input::placeholder {
	color: #ecf0f1;
}

.color-option > span {
	border-radius: 1px;
	display: inline-block;
	height: 10px;
	margin: 0 8px 0 0;
	width: 10px;
}

.selectr-tag {
	background-color: transparent;
	border: 1px solid #999;
	border-radius: 0;
	color: #000;
	margin: 0 5px 2px 0;
	padding: 1px 25px 1px 8px;
}

.selectr-tag-remove::after,
.selectr-tag-remove::before {
	background-color: #6c7a86;
	width: 2px;
}

.selectr-option{
    color: black;
}

.select_multiple_genres{
    border-radius: 10px;
}

.filter_block input{
    border-radius: 8px;
    border: none;
    font-family: 'Montserrat';
}

.filter_block .values:before{
    content: "";
    position: absolute;
    height: 0;
    width: 0;
    border-top: 10px solid rgb(13, 110, 253);
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    margin: auto;
    bottom: -9px;
    left: 0;
    right: 0;
}

.from_year{
    margin-left: 10px;
    margin-bottom: 10px;
}
.range_year_wrapper{
    margin-right: 6px;
}



/* DOUBLE RANGE SLIDER */

.wrapper{
    position: relative;
    background-color: #22222269;;
    padding: 24px 40px 0 40px;
    border-radius: 10px;
    margin-bottom: 10px;
    border: 1px solid #5555555e;
}
.container{
    position: relative;
    width: 100%;
    height: 67px;
    margin-top: -15px;;
}
input[type="range"]{
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;
    outline: none;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    background-color: transparent;
    pointer-events: none;
}
.slider-track{
    width: 100%;
    height: 5px;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    border-radius: 5px;
}
input[type="range"]::-webkit-slider-runnable-track{
    -webkit-appearance: none;
    height: 5px;
}
input[type="range"]::-moz-range-track{
    -moz-appearance: none;
    height: 5px;
}
input[type="range"]::-ms-track{
    appearance: none;
    height: 5px;
}
input[type="range"]::-webkit-slider-thumb{
    -webkit-appearance: none;
    height: 1.7em;
    width: 1.7em;
    background-color: #3264fe;
    cursor: pointer;
    margin-top: -9px;
    pointer-events: auto;
    border-radius: 50%;
}
input[type="range"]::-moz-range-thumb{
    -webkit-appearance: none;
    height: 1.7em;
    width: 1.7em;
    cursor: pointer;
    border-radius: 50%;
    background-color: #3264fe;
    pointer-events: auto;
}
input[type="range"]::-ms-thumb{
    appearance: none;
    height: 1.7em;
    width: 1.7em;
    cursor: pointer;
    border-radius: 50%;
    background-color: #3264fe;
    pointer-events: auto;
}
input[type="range"]:active::-webkit-slider-thumb{
    background-color: #ffffff;
    border: 3px solid #3264fe;
}
.values{
    background-color: rgb(13, 110, 253);
    width: 110px;
    position: relative;
    margin: auto;
    padding: 4px 0;
    border-radius: 5px;
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
}




@media only screen and (max-width: 768px) {
    .titles-filter{
        margin: 0 20px 0 20px;
    }

    
    .filter_block{
        flex-wrap: wrap;
    }

    .range_year_wrapper{
        width: 100%;
    }

    .select_wrapper{
        min-width: 140px;
        max-width: 140px;
        margin-bottom: 10px;
    }

    .selects_wrapper{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
}

</style>